export default __webpack_public_path__ + "static/media/business01.55592800.png";